import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./../../css/products.scss";

import sagacityinsuranceapi11x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-1-1x.png"
import sagacityinsuranceapi12x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-1-2x.png"
import sagacityinsuranceapi21x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-2-1x.png"
import sagacityinsuranceapi22x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-2-2x.png"
import sagacityinsuranceapi31x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-3-1x.png"
import sagacityinsuranceapi32x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-3-2x.png"
import sagacityinsuranceapi41x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-4-1x.png"
import sagacityinsuranceapi42x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-4-2x.png"
import sagacityinsuranceapi51x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-5-1x.png"
import sagacityinsuranceapi52x from "./../../images/sagacityinsuranceapi/sagacityinsuranceapi-5-2x.png"

import imgPineapple1 from "./../../img/imgPineapple1.svg"

function InsuranceApiPlatform(props) {
	
	const [sagacityinsuranceapi1WD, setSagacityinsuranceapi1WD] = useState('');
	const [sagacityinsuranceapi2WD, setSagacityinsuranceapi2WD] = useState('');
	const [sagacityinsuranceapi3WD, setSagacityinsuranceapi3WD] = useState('');
	const [sagacityinsuranceapi4WD, setSagacityinsuranceapi4WD] = useState('');
	const [sagacityinsuranceapi5WD, setSagacityinsuranceapi5WD] = useState('');
	
   useEffect(() => {
	  if( props.wd < 1200 ){
		  setSagacityinsuranceapi1WD(sagacityinsuranceapi11x);
		  setSagacityinsuranceapi2WD(sagacityinsuranceapi21x);
		  setSagacityinsuranceapi3WD(sagacityinsuranceapi31x);
		  setSagacityinsuranceapi4WD(sagacityinsuranceapi41x);
		  setSagacityinsuranceapi5WD(sagacityinsuranceapi51x);
	  } else if( props.wd >= 1200 ){
		  setSagacityinsuranceapi1WD(sagacityinsuranceapi12x);
		  setSagacityinsuranceapi2WD(sagacityinsuranceapi22x);
		  setSagacityinsuranceapi3WD(sagacityinsuranceapi32x);
		  setSagacityinsuranceapi4WD(sagacityinsuranceapi42x);
		  setSagacityinsuranceapi5WD(sagacityinsuranceapi52x);
	  }
   },[props.wd]);

  return (
  
      <div>
        <Container>
          <div className="wrapBG">
            <Row className="wrapRowinsuranceApiPlatform1">
              <Col xl="6" lg="6" md="12" sm="12">
                <h1 className="h1insuranceApiPlatform h2insuranceApiPlatform1">
                  <span>Платформа API</span><br/>для страхування
                </h1>
                <p className="pProducts width80">
                  Sagacity Insurance API платформа дає можливість легко інтегрувати ваші процеси продажів з інфраструктурою ваших партнерів.
                </p>
                <a href="/ua/contact" className="btn buttonOne aProduct">
                  Зв'язатися
                </a>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={sagacityinsuranceapi1WD} alt="" className="imgSagacityInsuranceAPI1"/>
              </Col>
            </Row>
            <Row className="wrapRowinsuranceApiPlatform2">
              <Col xl="6" lg="6" md="12" sm="12" className="imfageTop">
                <img src={sagacityinsuranceapi2WD} alt="" className="imgSagacityInsuranceAPI2"/>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products h2insuranceApiPlatform2">ШВИДКЕ НАЛАШТУВАННЯ ПРОДУКТУ ЗА ДОПОМОГОЮ НАШОЇ ПАНЕЛІ КОНФІГУРАЦІЇ</h2>
                <p className="pProducts">
                  - Створюйте страхові продукти без зусиль.
                  <br/> - Налаштовуйте правила розрахунку тарифів та перевірки.
                  <br/> - Встановлюйте індивідуальний процес продажу.</p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12" className="imfageBottom">
                <img src={sagacityinsuranceapi2WD} alt="" className="imgSagacityInsuranceAPI2"/>
              </Col>
            </Row>
            <Row className="wrapRowinsuranceApiPlatform3">
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products h2insuranceApiPlatform3">ГОТОВИЙ ДО ВИКОРИСТАННЯ API ДЛЯ ОПТИМІЗАЦІЇ ВСЬОГО ПРОЦЕСУ ПРОДАЖУ</h2>
                <p className="pProducts">
                  Наш API спрощує такі важливі функції:
                  <br/> - Миттєвий розрахунок ціни.
                  <br/> - Легкий вибір покриття.
                  <br/> - Автоматизована перевірка бізнес-правил продукту.
                  <br/> - Підписання контракту онлайн без зусиль.
                  <br/> - Швидка генерація друкованої форми контракту.</p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={sagacityinsuranceapi3WD} alt="" className="imgSagacityInsuranceAPI3"/>
              </Col>
            </Row>
            <Row className="wrapRowinsuranceApiPlatform4">
            <Col xl="6" lg="6" md="12" sm="12" className="imfageTop">
                <img src={sagacityinsuranceapi4WD} alt="" className="imgSagacityInsuranceAPI2"/>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products h2insuranceApiPlatform4">Продавайте повний спектр страхових продуктів онлайн</h2>
                <p className="pProducts">API Sagacity є універсальним і підтримує широкий спектр страхових продуктів, включаючи страхування авто, подорожей, нерухомості, гаджетів, медичне страхування та інше.</p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12" className="imfageBottom">
                <img src={sagacityinsuranceapi4WD} alt="" className="imgSagacityInsuranceAPI2"/>
              </Col>
            </Row>
            <Row className="wrapRowinsuranceApiPlatform5">
              <Col xl="6" lg="6" md="12" sm="12">
                <h2 className="h2Products h2insuranceApiPlatform5">Налаштуйте бізнес-процеси для підтримки вашого відділу продажів</h2>
                <p className="pProducts">- Отримуйте доступ до всіх необхідних даних через панель управління продажами.
                  <br/>- Переглядайте пропозиції та контракти для оптимізації вашої діяльності з продажів.</p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <img src={sagacityinsuranceapi5WD} alt="" className="imgSagacityInsuranceAPI5"/>
              </Col>
            </Row>
            <Row className="wrapRowProducts6">
              <Col xl="6" lg="6" md="12" sm="12">
                <img
                  src={imgPineapple1}
                  alt=""
                  className="imgPineappleProduct"
                />
                <h2 className="h2Products">Хочете дізнатися більше?</h2>
                <p className="pProducts">
                  Розкажіть про потреби вашого бізнесу. Ми знайдемо ідеальне
                  рішення.
                </p>
              </Col>
              <Col xl="6" lg="6" md="12" sm="12">
                <a href="/ua/contact" className="btn buttonOne buttonProduct">Зв'язатися</a>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

  );
}

export default InsuranceApiPlatform;
